import axios from "axios";
import { store, logout } from "../redux/internal";
import { toast } from "react-toastify";
import { baseURL } from "../constants/urls";

export const axiosInstance = axios.create({
  baseURL: baseURL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token && config.headers) {
    config.headers["Authorization"] = `Bearer ${token.access_token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,
    if (error?.request?.status === 401) {
      toast.error("Your session has expired, please log back in.", { toastId: 401 });
      setTimeout(() => {
        void store.dispatch(logout());
      }, 3000);
    } else {
      toast.error(axios.isAxiosError(error) ? error.message : (error as string));
    }

    return Promise.reject(error);
  },
);
